import { useState, useEffect } from "react";
import Switch from "react-switch";
import { useTheme } from "styled-components";
import { shade } from "polished";
import { LoggedUser } from "components/LoggedUser";
import { Container, Content, PageSidebar } from "pages/Users/styles";
import { useAuth } from "hooks/useAuth";
import { AdminList } from "types/User";
import { useInstabilityAlert } from "hooks/fetch/useInstabilityAlert";
import { useUpdateInstabilityAlert } from "hooks/mutations/useUpdateInstabilityAlert";
import styled from "styled-components";

const PageContent = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow-y: auto;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
`;

const SettingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Label = styled.span`
  font-size: 0.9375rem;
  color: ${props => props.theme.colors.text};
`;

const TextArea = styled.textarea`
  width: 100%;
  max-width: 600px;
  min-height: 140px;
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-size: 0.9375rem;
  resize: vertical;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primary};
  }
`;

const SaveButton = styled.button`
  padding: 0.5rem 1.5rem;
  background: ${props => props.theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.9375rem;
  cursor: pointer;
  align-self: flex-start;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export function InstabilityAlert() {
  const { user } = useAuth();
  const theme = useTheme();
  const { data, isLoading } = useInstabilityAlert();
  const { mutate, isLoading: isSaving } = useUpdateInstabilityAlert();

  const [enabled, setEnabled] = useState(false);
  const [body, setBody] = useState('');

  useEffect(() => {
    if (!data) return;
    setEnabled(data.instability_alert_enabled);
    setBody(data.instability_alert_body ?? '');
  }, [data]);

  if (user == null || !AdminList.includes(user.name)) {
    return (
      <Container>
        <Content>
          <PageSidebar>
            <LoggedUser />
          </PageSidebar>
          <div style={{ alignSelf: "center", justifySelf: "center" }}>
            <h2>Você não tem permissão para acessar essa página!</h2>
          </div>
        </Content>
      </Container>
    );
  }

  function handleSave() {
    mutate({ instability_alert_enabled: enabled, instability_alert_body: body });
  }

  return (
    <Container>
      <Content>
        <PageSidebar>
          <LoggedUser />
        </PageSidebar>
        <PageContent>
          <Title>Alerta de instabilidade</Title>

          {isLoading ? (
            <span>Carregando...</span>
          ) : (
            <>
              <SettingRow>
                <Label>Ativar alerta automático</Label>
                <Switch
                  onChange={setEnabled}
                  checked={enabled}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  height={10}
                  width={40}
                  handleDiameter={20}
                  offHandleColor={theme.colors.switchHandler}
                  onHandleColor={theme.colors.switchHandler}
                  offColor={shade(0.15, theme.colors.main)}
                  onColor={theme.colors.primary}
                />
              </SettingRow>

              <div>
                <Label>Conteúdo do alerta</Label>
                <br /><br />
                <TextArea
                  value={body}
                  onChange={e => setBody(e.target.value)}
                  placeholder="Digite a mensagem de alerta de instabilidade..."
                />
              </div>

              <SaveButton onClick={handleSave} disabled={isSaving}>
                {isSaving ? 'Salvando...' : 'Salvar'}
              </SaveButton>
            </>
          )}
        </PageContent>
      </Content>
    </Container>
  );
}
